import { type ReactNode } from 'react';
import { StyledLabel } from './style';

export type LabelProps = {
  children: ReactNode;
  slim?: boolean;
  variant?: 'neutral' | 'warning' | 'error' | 'success' | 'info';
  badge?: boolean;
};

export const Label = ({ children, variant = 'neutral', slim, badge }: LabelProps) => {
  return (
    <StyledLabel variant={variant} slim={slim} badge={badge}>
      {children}
    </StyledLabel>
  );
};
